var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54243 18.0661L0.5 21.2883L22.3317 32.6751L45.5 21.2883L37.9888 17.7828L23.9978 25.3568L22.3097 26.2706L20.6318 25.3384L7.54243 18.0661ZM15.4464 14.4496L23.2228 10.8916L30.0924 14.0976L22.3535 18.2871L15.4464 14.4496Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63448 30.3488L0.5 33.6132L22.3317 45L45.5 33.6132L37.8909 30.062L23.9287 37.2223L22.3132 38.0508L20.7054 37.2072L7.63448 30.3488ZM16.7459 27.2246L24.1206 25.7905L29.0494 26.7294L22.35 30.1651L16.7459 27.2246Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3317 21.7835L0.5 10.3967L23.2228 0L45.5 10.3967L22.3317 21.7835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard7);
export default __webpack_public_path__ + "static/media/card7.90e2dd7847d0fe035342d46a61ffcaad.svg";
export { ForwardRef as ReactComponent };